import { Timeline } from 'react-twitter-widgets';

export function TwitterTimelineWidget({ url }: { url: string }) {
  const TwitterObj = getTwitterUserId(url);

  if (!TwitterObj.isTwitterUsername) return null;
  return (
    <div data-testid="twitter-timeline">
      <Timeline
        dataSource={{
          sourceType: 'profile',
          userId: TwitterObj.username,
        }}
        options={{
          width: '100%',
          chrome: 'nofooter noheader',
          tweetLimit: 3,
          dnt: true,
        }}
      />
    </div>
  );
}

export function getTwitterUserId(url: string) {
  const TwitterUserIdExp = new RegExp(
    /^https?:\/\/(www\.)?twitter.com\/i\/user\/?/
  );
  let returnObj: { isTwitterUsername?: boolean; username?: string } = {};

  if (url === '') {
    returnObj = { ...returnObj, isTwitterUsername: false, username: '' };
  }

  if (TwitterUserIdExp.test(url)) {
    returnObj = {
      ...returnObj,
      isTwitterUsername: true,
      username: url.replace(TwitterUserIdExp, ''),
    };
  } else {
    returnObj = {
      ...returnObj,
      isTwitterUsername: false,
      username: url.replace(TwitterUserIdExp, ''),
    };
  }
  return returnObj;
}
